"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.thdOrange = exports.thdLink = exports.evil = exports.darkText = exports.darkGreen = exports.dangerRed = exports.celesteApprox = exports.borderColor = exports.blazeOrangeApprox = exports.black = void 0;
var celesteApprox = '#ccc';
exports.celesteApprox = celesteApprox;
var blazeOrangeApprox = 'rgb(249, 99, 2)';
exports.blazeOrangeApprox = blazeOrangeApprox;
var thdLink = '#3e7697';
exports.thdLink = thdLink;
var thdOrange = '#F96302';
exports.thdOrange = thdOrange;
var darkText = '#333';
exports.darkText = darkText;
var borderColor = '#999';
exports.borderColor = borderColor;
var darkGreen = '#00873c';
exports.darkGreen = darkGreen;
var black = '#000';
exports.black = black;
var white = '#fff';
exports.white = white;
var dangerRed = '#D81118';
exports.dangerRed = dangerRed;
var evil = '#666';
exports.evil = evil;
//# sourceMappingURL=colors.js.map